import http from '../http-common'

const getProjectStatus = () => {
  return http.get('/project-status')
}

export const projectStatusService = {
  getProjectStatus,
}
